import { render, staticRenderFns } from "./StaffEdit.vue?vue&type=template&id=188ee8a6&scoped=true&"
import script from "./StaffEdit.vue?vue&type=script&lang=ts&"
export * from "./StaffEdit.vue?vue&type=script&lang=ts&"
import style0 from "./StaffEdit.vue?vue&type=style&index=0&id=188ee8a6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "188ee8a6",
  null
  
)

export default component.exports